// removed by extract-text-webpack-plugin
module.exports = {"easeInQuad":"cubic-bezier(.55,.085,.68,.53)","easeOutQuad":"cubic-bezier(.25,.46,.45,.94)","content":"workmenu__content___3AJlR","isActive":"workmenu__isActive___3_W5L","enter":"workmenu__enter___2ABc3","enterActive":"workmenu__enterActive___3a1V2","leave":"workmenu__leave___lsMWc","leaveActive":"workmenu__leaveActive___3MeRb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/WorkMenu/workmenu.css
// module id = 169
// module chunks = 0